// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import withOnMount from "hoc/withOnMount"
import withConnect from "hoc/withConnect"
import { Container } from "componentsStyled/Layout/Containers"
import { H1, Text } from "componentsStyled/Typography"
import { logout } from "data/user/actions"
import Button from "components/Button"

const ErrorPage = () => (
  <Container center>
    <H1>This wave was too high!</H1>
    <Text center>
      Application crashed. This incident was reported and our developers will be working on a fix.
      <br />
      We&apos;re sorry for the inconvenience.
    </Text>
    <Button onClick={() => window.location.reload(true)}>
      Return to homepage
    </Button>
  </Container>
)

const enhancer: HOC<*, {}> = compose(
  withConnect(() => ({}), { logout }),
  withOnMount(props => {
    if (window.location.hostname !== "localhost") {
      // HACK: Log the user out in case of corrupted state
      props.logout()
    }
  }),
)

export default enhancer(ErrorPage)



// WEBPACK FOOTER //
// ./src/pages/Error/index.js